import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set page title
document.title = 'Brazil - QTap';
// Prevent browser from restoring scroll position on refresh
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);
render(<App data-id="element-376" />, document.getElementById('root'));